import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {MaintenanceComponent} from "./components/maintenance.component";


const routes = [{
  path: "maintenance",
  component: MaintenanceComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class MaintenanceRoutingModule {
}
